/**
 * Whether the current user can see the Pitch Deck feature.
 *
 * Used to gate the sidebar nav entry. This checks the same feature flag as
 * PitchDeckAccessGuard (via the SECURITY DEFINER RPC in featureFlags.ts), but
 * deliberately does NOT evaluate prerequisites — those only control an
 * informational banner inside the feature, not whether it is reachable.
 */

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { checkFeatureAccess } from "@/lib/pitch-deck/featureFlags";

export function usePitchDeckAccess() {
  const { user } = useAuth();

  const { data } = useQuery({
    queryKey: ["pitch-deck-feature-access", user?.id],
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const result = await checkFeatureAccess("pitch_deck_generation", user!.id);
      return result.hasAccess;
    },
  });

  return { hasPitchDeckAccess: data === true };
}
